module.exports = __webpack_public_path__ + "static/media/Icon-SwitchTeam.18d7de5c.svg";